import user, {
  reducer as userReducer,
  initialState as userInitialState,
} from "./user";

import entity, {
  reducer as entityReducer,
  initialState as entityInitialState,
} from "./entity";

import map, {
  reducer as mapReducer,
  initialState as mapInitialState,
} from "./map";

import antd, {
  reducer as antdReducer,
  initialState as antdInitialState,
} from "./antd";

import communications, {
  reducer as communicationsReducer,
  initialState as communicationsInitialState,
} from "./communications";

import callQueue, {
  reducer as callQueueReducer,
  initialState as callQueueInitialState,
} from "./callQueue";

import callVoicemails, {
  reducer as callVoicemailsReducer,
  initialState as callVoicemailsInitialState,
} from "./callVoicemails";

import activities, {
  reducer as activitiesReducer,
  initialState as activitiesInitialState,
} from "./activities";

export const actions = {
  user,
  entity,
  map,
  antd,
  communications,
  callQueue,
  callVoicemails,
  activities,
};

export const reducers = {
  user: userReducer,
  entity: entityReducer,
  map: mapReducer,
  antd: antdReducer,
  communications: communicationsReducer,
  callQueue: callQueueReducer,
  callVoicemails: callVoicemailsReducer,
  activities: activitiesReducer,
};

export const initialState = {
  user: userInitialState,
  entity: entityInitialState,
  map: mapInitialState,
  antd: antdInitialState,
  communications: communicationsInitialState,
  callQueue: callQueueInitialState,
  callVoicemails: callVoicemailsInitialState,
  activities: activitiesInitialState,
};

export default actions;
